


// import React, { useState } from 'react';
// import IndianProfileForm from './IndianProfileForm';
// import ForeignProfileForm from './ForeignProfileForm';

// function ProfileComponent() {
//   const [formType, setFormType] = useState('Indian'); // State to manage the selected form type

//   return (
//     <div className="flex justify-center w-full ">
//       <div className="flex w-full ">
//         <div className=" p-4">
//           {/* Card Structure */}
//           <div className="bg-white shadow-md rounded-lg p-6">
//             {/* Radio buttons for Indian and Foreigner */}
//             <div className="flex items-center space-x-6 mb-6">
//               <div className="flex items-center space-x-2">
//                 <input
//                   type="radio"
//                   id="indian"
//                   name="profileType"
//                   checked={formType === 'Indian'}
//                   onChange={() => setFormType('Indian')}
//                   className="form-radio"
//                 />
//                 <label htmlFor="indian" className="font-semibold text-gray-600">Indian</label>
//               </div>

//               <div className="flex items-center space-x-2">
//                 <input
//                   type="radio"
//                   id="foreigner"
//                   name="profileType"
//                   checked={formType === 'Foreigner'}
//                   onChange={() => setFormType('Foreigner')}
//                   className="form-radio"
//                 />
//                 <label htmlFor="foreigner" className="font-semibold text-gray-600">Foreigner</label>
//               </div>
//             </div>

//             {/* Conditionally render the form based on selected type */}
//             {formType === 'Indian' ? <IndianProfileForm /> : <ForeignProfileForm />}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ProfileComponent;

import React, { useState } from 'react';
import IndianProfileForm from './IndianProfileForm';
import ForeignProfileForm from './ForeignProfileForm';

function ProfileComponent() {
  const [formType, setFormType] = useState('Indian'); // State to manage the selected form type

  return (
    <div className="w-full flex justify-center bg-gray-100">
   
      {/* Outer Container */}
      <div className="w-full border rounded-lg">
     
        {/* Card Structure */}
        <div className="bg-white rounded-lg p-6">
          {/* Radio buttons for Indian and Foreigner */}
          <div className="flex items-center space-x-6 mb-6">
            <div className="flex items-center space-x-2">
              <input
                type="radio"
                id="indian"
                name="profileType"
                checked={formType === 'Indian'}
                onChange={() => setFormType('Indian')}
                className="form-radio"
              />
              <label htmlFor="indian" className="font-semibold text-gray-600">
                Indian
              </label>
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="radio"
                id="foreigner"
                name="profileType"
                checked={formType === 'Foreigner'}
                onChange={() => setFormType('Foreigner')}
                className="form-radio"
              />
              <label htmlFor="foreigner" className="font-semibold text-gray-600">
                Foreigner
              </label>
            </div>
          </div>

          {/* Conditionally render the form based on selected type */}
          {formType === 'Indian' ? <IndianProfileForm /> : <ForeignProfileForm />}
        </div>
      </div>
    </div>
  );
}

export default ProfileComponent;
